<template>
    <div class="">

        <div class="card mt-3 border-0 bg-wash no-shadow">
            <div class="col-12 text-right pr-3 company-form-box-title">
                <button v-if="is_eligible==1" class="btn btn-block btn-secondary tab-button"  @click="addNew()"  > Add Loan </button>
            </div>  
            <b-overlay :show="showoverlay_list" rounded="sm">
            <div v-if="loans.length > 0" class=" p-4">    
                             
                <div class="row table-head">
                    <div class="col-sm-2 font-weight-bold py-1">
                         Loan ID
                    </div>                       
                    <div class="col-sm-2 font-weight-bold py-2 text-right">
                        Amount
                    </div>
                    <div class="col-sm-2 font-weight-bold py-2">
                         Deduction Start Month
                    </div>
                    <div class="col-sm-2 font-weight-bold py-2">
                         Effective Date
                    </div>
                    <div class="col-sm-1 font-weight-bold py-2">
                         Tenure
                    </div>
                    <div class="col-sm-1 font-weight-bold py-2">
                        Status
                    </div>
                    
                    <div class="col-sm-2 font-weight-bold py-2 text-right"  v-if="flg > 0">    
                        Actions                              
                    </div>
                </div>
            
                <div class="row table-row hover-bg" v-for="loan in loans" :key="loan.id">
                    <div class="col-sm-2 py-2 align-items-center d-flex">                    
                        <div class="">{{loan.company_loan_id}}</div>
                    </div>
                    <div class="col-sm-2 py-2 text-right">
                         <div class="">{{formatMoney(loan.loan_amount)}}</div>
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex">
                        <div>{{loan.deduction_start_month}}</div> 
                    </div>
                    <div class="col-sm-2 py-2 align-items-center d-flex">
                        <div>{{loan.effective_date_of_loan}}</div> 
                    </div>
                    
                    <div class="col-sm-1 py-2 align-items-center d-flex">
                        <div>{{loan.loan_tenure}} Month(s)</div>
                    </div>
                    <div class="col-sm-2 py-1 align-items-center d-flex">
                        <div>
                         {{loan_stat_title_2[loan.status]}} 
                        </div>
                        
                    </div>
                    <div class="col-sm-1 clearfix py-2 text-right position-relative d-flex align-items-center justify-content-end"  v-if="flg > 0"> 
                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>                               
                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                            <b-button-toolbar class="custom-btn-toolbar">
                                <b-button-group class="d-flex flex-column flex-grow-1">

                                    <b-button class="border-0 rounded mb-1"  v-if="loan.has_tx==0  && (loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Pause/Stopped'|| loan_stat_title[loan.status] == 'Declined')" variant="outline-secondary" title="Edit Bank Account Info" @click="editLoanInfo(loan.id,loan.employee_name,0,2)"> 
                                         <i class="fas fa-check-double"></i> Approve
                                    </b-button>
                                    <b-button class="border-0 rounded mb-1"  v-if="loan.has_tx==0  && (loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Declined')" variant="outline-secondary" title="Edit Bank Account Info" @click="showUnApproveModal(loan.id)"> 
                                        <i class="fas fa-undo-alt"></i>  Unapprove
                                    </b-button>  
                                    <b-button class="border-0 rounded mb-1"  v-if="loan_stat_title[loan.status] == 'Approved'" variant="outline-secondary" title="Edit Bank Account Info" @click="editLoanInfo(loan.id,loan.employee_name,0,3)"> 
                                        <i class="fas fa-pause"></i> Pause / Stop
                                    </b-button> 
                                    <b-button class="border-0 rounded mb-1"  v-if="loan.has_tx==0  && (loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Approved')" variant="outline-secondary" title="Edit Bank Account Info" @click="showDeclineModal(loan.id)"> 
                                        <i class="fas fa-ban"></i> Decline
                                    </b-button>
                                     <b-button class="border-0 rounded mb-1"  v-if="loan.has_tx==0  && (loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Declined' || loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Pause/Stopped')" variant="outline-secondary" title="Edit Bank Account Info" @click="showDeleteModal(loan.id)"> 
                                        <i class="fas fa-times"></i>  Delete
                                    </b-button> 
                                    <b-button class="border-0 rounded mb-1" variant="outline-secondary" v-if="loan_stat_title[loan.status] == 'Applied' || loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Pause/Stopped' || loan_stat_title[loan.status] == 'Declined'"  title="Edit Bank Account Info" @click="editLoanInfo(loan.id,loan.employee_name,0,0)">
                                         <i class="fas fa-edit"></i>Edit
                                    </b-button>
                                    <b-button class="border-0 rounded mb-1"  v-if="loan_stat_title[loan.status] == 'Approved'" variant="outline-secondary" title="Edit Bank Account Info" @click="editLoanInfo(loan.id,loan.employee_name,1,0)"> 
                                        <i class="fas fa-money-bill-alt"></i>  Manual Payment 
                                    </b-button>
                                    <b-button class="border-0 rounded mb-1"  v-if="loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Pause/Stopped' " variant="outline-secondary" title="Edit Bank Account Info" @click="showInstallment(loan.id)"> 
                                        <i class="fab fa-delicious"></i> Installments
                                    </b-button>
                                    <b-button class="border-0 rounded mb-1" variant="outline-secondary" title="Loan Details" @click="showLoanTransactions(loan.id)"> 
                                        <i class="fas fa-table"></i> Transactions
                                    </b-button>
                                </b-button-group>
                            </b-button-toolbar>
                        </div>
                    </div>
                </div>                         
            </div>
            <div v-else class=" p-4">  
                
                <div v-if="show_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Sorry no loan to show. 
                </div>
            </div>
        </b-overlay>   
        </div>
        
        <b-modal id="decline-modal" title="Are you sure you want to decline this Loan ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Decline <span v-if="loading != ''"><img :src="this.$api_url+'/public/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('decline-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="delete-modal" title="Are you sure you want to delete this Loan ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteLoan(loan_entity_id)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/public/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="unapprove-modal" title="Are you sure you want to unapprove this Loan ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Unapprove <span v-if="loading != ''"><img :src="this.$api_url+'/public/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('unapprove-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title">
            <gf-loan-form :pageurl="this.$api_url" :flg="flg" :employee_id="employee_id" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="updateLoanData"></gf-loan-form>
        </b-modal>
        <b-modal id="bv-modal-gf-loan-transactions-wizard" size="lg" hide-footer v-bind:title="modal_title">
            <gf-loan-transactions-wizard :pageurl="this.$api_url" :employee_id="employee_id" :key="tx_popup_count" :loan_id="loan_id" ></gf-loan-transactions-wizard>                  
        </b-modal>

        <b-modal id="installment-modal" title="Installment Breakdown" hide-footer> 
        <div class="row table-head">
            <div class="col-sm-4 font-weight-bold py-2">
                Installment No.
            </div>                      
            <div class="col-sm-4 font-weight-bold py-2">
                Month
            </div>
            <div class="col-sm-4 font-weight-bold py-2">
                Amount
            </div>
        </div>
        <div class="row table-row hover-bg"  v-for="(row, index) in my_installments" :key="index">
            <div class="col-sm-4 py-2 align-items-center d-flex">                    
                <div :style="(row.status==3) ? styleA : styleB" >Installement #{{index+1}}</div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">                    
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.month)}}</div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.amount)}}</div>
            </div>
        </div>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        
    </div>
</template> 

 
<script>
    export default{
        
        mounted() {
             
        },
        props: ['pageurl','bn' ,'flg','employee_id'],
        data(){            
            
            return {
                
                loans:[],
                successmsg:'',
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#212529 !important',
                is_status:'',
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                loan_stat_title_2: ["Declined","Applied","Open","Pause/Stopped","Closed"],
                loan_stat_div: ["text-danger","text-info","text-success","text-muted","text-purple"],
                default_tenure: [0,12,1],
                curr_process_name: '',
                curr_process_id:'',
                e_name:'',
                e_id:'',
                showoverlay_list : false,       
                disableme: false,    
                disable_submit :false,             
                successmsg:'',
                show_loader:true,
                errormsg:[],
                selected_bank_id:0,
                loading:'',
                loan_title:'',
                amount_title: '',
                showoverlaymodal : false,
                loan_entity_id:'',
                loan_update_status:'',
                loan_type: 1,
                loan_id :0,
                tx_popup_count:0,
                modal_title:"",
                is_custom:0,
                my_installments:[],
                
                count:0, 
                loan_types_drop : ['','Loan','Advance'],
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Decline" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approve" },
                    { value: "3", text: "Pause/Stop" },
                ],
                loan_type_vals:[
                    { value: "1", text: "Loan" }, 
                    { value: "2", text: "Advance" },

                ],
                m_lists : [],
                is_eligible:1,
            }
        },
        methods:{
            

            showUnApproveModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 1;
            this.$bvModal.show('unapprove-modal');
            },
            showDeclineModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 0;
            this.$bvModal.show('decline-modal');
            },
            showDeleteModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.$bvModal.show('delete-modal');
            },
            showInstallment: function(loan)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                let formData = new FormData();
                formData.append('loan_id', loan);   
                this.my_installments = [];
                this.showoverlay = true;
                axios.post(this.$api_url+'/gf/loan/installments', formData)
                .then(function (response) 
                {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');
                        
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            showLoanTransactions: function(loan_id,employee_id)
            { 
                this.loan_id = loan_id;
                this.employee_id = employee_id;
                this.tx_popup_count = this.tx_popup_count + 1;
                this.$bvModal.show('bv-modal-gf-loan-transactions-wizard');
            },
            pauseLoan: function(pageflg)
            {
                
                this.loading='load';
                var update_status = this.loan_update_status;
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                formData.append('status', update_status); 
                axios.post(this.$api_url+'/gf/loan/loan-update-status', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal');
                        this.$bvModal.hide('delete-modal');
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.updateLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                            
            },
            deleteLoan: function(pageflg)
            {
                
                this.loading='load';
              
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
               
                axios.post(this.$api_url+'/gf/loan/loan-delete', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal');
                        this.$bvModal.hide('delete-modal');
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.updateLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                            
            },
            
            getLoanData: function()
            {
                this.updateTransactions();
                this.$bvModal.hide('bv-modal-loan');
                this.loan_title = 'Emloyee Loan List';
                if(!this.checkNet()) return false;
                let currentObj = this; 
                this.show_loader=true;
                
                axios.get(this.$api_url+'/gf/loan/list' , {
                    params: {
                        employee_id: this.employee_id
                    }
                }).then(function(response){
                    this.loans = response.data;
                    //this.$emit('childToParent', value);
                    if(this.loans.length > 0)
                    {
                        this.e_name = this.loans[0].employee_name;
                        this.e_id = this.loans[0].employee_id;
                        this.is_eligible = this.loans[0].is_eligible;
                    }
                    
                    this.show_loader=false;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            updateLoanData: function()
            {
                this.updateTransactions(); 
                this.$bvModal.hide('bv-modal-loan');
                this.loan_title = 'Emloyee Loan List';
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/gf/loan/list' , {
                    params: {
                        employee_id: this.employee_id
                    }
                }).then(function(response){
                    this.loans = response.data;

                    if(this.loans.length > 0)
                    {
                        this.is_eligible = this.loans[0].is_eligible;
                    }
                    
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            validateState(ref)
            {
                if ( 
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/gf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            addNew()
            {
                //alert(this.e_name);
                this.is_custom = 0;
                this.is_status= 0;
                this.loan_id = 0;
                this.count = this.count + 1;
                this.modal_title = "Process Gf Loan for " +this.e_name;
                this.$bvModal.show('bv-modal-loan');
                
            },
            formatMoney: function(amount){
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },  
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, ''); 
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            editLoanInfo(loan_id,name,is_custom,status)
            {
                this.curr_process_name = name;
                this.curr_process_id = loan_id;
                this.modal_title = "Edit GF Loan";
                this.is_custom = is_custom;
                if(is_custom)
                {
                    this.modal_title = "Manual Payment";
                }
                if(this.curr_process_name.length >0)
                this.modal_title += " for "+this.curr_process_name;
                this.is_status= status;
                this.loan_id = loan_id;
                this.count = this.count + 1;
                this.$bvModal.show('bv-modal-loan');
            },
        },
        created: function()
        {
            this.getLoanData(); 
        } 
    }
</script>